/**
 * Reducer for the Common Balance Pool builder — the package's `ACTIONS = Object.freeze({...TPEAction})`
 * + `switch(action.type)` convention (cf. TPAllocationReducer / CalculationBuilderReducer).
 */
import TPEAction from 'src/models/common/TPEAction';
import { CommonBalancePoolBuilderState, getInitialState } from './CommonBalancePoolBuilderState';

export const ACTIONS = Object.freeze({
    RESET: new TPEAction('RESET'),
    SET_POOL: new TPEAction('SET_POOL'),
    SET_LOADING: new TPEAction('SET_LOADING'),
    SET_ERROR: new TPEAction('SET_ERROR'),
    SET_POOL_NEEDS_REFRESH: new TPEAction('SET_POOL_NEEDS_REFRESH'),
    SET_SAVING: new TPEAction('SET_SAVING'),
    SET_SAVE_ERROR: new TPEAction('SET_SAVE_ERROR'),
    SET_STEP2_DIRTY: new TPEAction('SET_STEP2_DIRTY'),
    OPEN_INPUT_MODAL: new TPEAction('OPEN_INPUT_MODAL'),
    CLOSE_INPUT_MODAL: new TPEAction('CLOSE_INPUT_MODAL'),
    SET_PERIOD: new TPEAction('SET_PERIOD'),
    SET_ACTION_BUSY: new TPEAction('SET_ACTION_BUSY'),
    SET_ACTION_ERROR: new TPEAction('SET_ACTION_ERROR'),
    SET_ACTION_NOTICE: new TPEAction('SET_ACTION_NOTICE'),
});

export function commonBalancePoolBuilderReducer(
    state: CommonBalancePoolBuilderState,
    action: TPEAction,
): CommonBalancePoolBuilderState {
    switch (action.type) {
        case ACTIONS.RESET.type:
            return getInitialState();
        case ACTIONS.SET_POOL.type:
            return { ...state, pool: action.payload, poolNeedsRefresh: false, isLoading: false };
        case ACTIONS.SET_LOADING.type:
            return { ...state, isLoading: action.payload };
        case ACTIONS.SET_ERROR.type:
            return { ...state, error: action.payload, isLoading: false };
        case ACTIONS.SET_POOL_NEEDS_REFRESH.type:
            return { ...state, poolNeedsRefresh: action.payload };
        case ACTIONS.SET_SAVING.type:
            return { ...state, saving: action.payload };
        case ACTIONS.SET_SAVE_ERROR.type:
            return { ...state, saveError: action.payload };
        case ACTIONS.SET_STEP2_DIRTY.type:
            return { ...state, step2Dirty: action.payload };
        case ACTIONS.OPEN_INPUT_MODAL.type:
            // payload = the InputRow to edit, or undefined to add a new input.
            return { ...state, addModalVisible: true, editingRow: action.payload, saveError: undefined };
        case ACTIONS.CLOSE_INPUT_MODAL.type:
            return { ...state, addModalVisible: false, editingRow: undefined };
        case ACTIONS.SET_PERIOD.type:
            return { ...state, period: action.payload };
        case ACTIONS.SET_ACTION_BUSY.type:
            return { ...state, actionBusy: action.payload };
        case ACTIONS.SET_ACTION_ERROR.type:
            return { ...state, actionError: action.payload };
        case ACTIONS.SET_ACTION_NOTICE.type:
            return { ...state, actionNotice: action.payload };
        default:
            // eslint-disable-next-line no-console
            console.warn(`No action found for ${action.type}. Returning unchanged state`);
            return state;
    }
}
